module.exports = __webpack_public_path__ + "static/Barb_and_Lee_737_engine-7ccc16be56b9bb2479872ddc8e3128a5.jpg";